/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76450ReqFieldConditionsItem {
  
  /** 字段名称 */
  fieldName?: string;
  
  /** 字段描述 */
  fieldDescription?: string;
  
};
    
  
    
export interface IAPI76450ReqModelTasksItemSuggestStartResultObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI76450ReqModelTasksItemSuggestEndResultObj {
  
  /** -9之前,+9之后 */
  day?: number;
  
  /** hh:mm */
  pointTime?: string;
  
};
    
  
    
export interface IAPI76450ReqModelTasksItem {
  
  /**  */
  dataId?: string;
  
  /** 版本号 */
  version?: number;
  
  /** 新版本号 */
  newVersion?: number;
  
  /** 节点ID */
  nodeId?: string;
  
  /** 父节点ID ,String */
  parentNodeIds?: string[];
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 节点标签 */
  nodeTag?: string;
  
  /** 节点描述 */
  nodeDesc?: string;
  
  /** 岗位 */
  role?: string;
  
  /** 触发方式,timeTarget:时间触发,nodeStart:节点开始触发,nodeEnd：节点完成触发 */
  triggerType?: string;
  
  /** 建议开始时间 ,TimeResp */
  suggestStartResult?: IAPI76450ReqModelTasksItemSuggestStartResultObj;
  
  /** 建议结束时间 ,TimeResp */
  suggestEndResult?: IAPI76450ReqModelTasksItemSuggestEndResultObj;
  
  /** 完成任务是否需要提交 */
  completeTaskNeedSubmit?: string;
  
  /** 完成任务是否需要提交 */
  completeTaskInformation?: string;
  
  /** 操作人名称 */
  operatorName?: string;
  
  /** 操作人id */
  operatorId?: string;
  
};
    
  



export interface API76450Req {
  
  /** 任务模型id */
  dataId?: string;
  /** 版本号 */
  version?: number;
  /** 任务条件要素 ,FieldCondition */
  fieldConditions?: IAPI76450ReqFieldConditionsItem[];
  /** 节点信息 ,ModelTaskSaveReq */
  modelTasks?: IAPI76450ReqModelTasksItem[];
};



export type API76450Res = {};


// 接口函数 76450 修改模型

export interface IUsePostAPI76450Return {
  /** 修改模型: 接口请求状态 */
  isAPI76450Loading: boolean;
  /** 修改模型: 接口请求返回数据 */
  dataAPI76450: API76450Res;
  /**  修改模型: 接口数据请求方法 */
  fetchAPI76450Data: (inputs: API76450Req, config?: YWRequestConfig) => Promise<API76450Res>;
  /** 修改模型: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76450 = ():IUsePostAPI76450Return => {
  let isMount = true;
  const [isAPI76450Loading, setIsAPI76450Loading] = useState(false);
  const [dataAPI76450, setDataAPI76450] = useState<API76450Res>({} as API76450Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/save/model`;

  const fetchAPI76450Data = async (inputs: API76450Req, config?: YWRequestConfig): Promise<API76450Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76450Req>) || {}) as API76450Req;
    
  
    if ( isMount ) {
      setIsAPI76450Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76450Res>(`${basePath}/yoaichat-web/chat/task/model/save/model`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76450(res || {} as API76450Res);
        setIsAPI76450Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76450Loading(false);
      }
      return false as unknown as API76450Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76450Loading,
    dataAPI76450,
    fetchAPI76450Data,
    requestUrl,
  }
}

